import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import '../../../styles/components/common/Popup.css';

const Popup = ({ title, message, onConfirm, onCancel, children, footer, className = '', disableOverlayClose, disableEscapeClose }) => {
  const [isClosing, setIsClosing] = useState(false);
  const mouseDownInside = useRef(false);
  const initiateClose = () => {
    if (isClosing) return;
    setIsClosing(true);
    setTimeout(() => {
      onCancel && onCancel();
    }, 300);
  };
  const handleOverlayClick = () => {
    if (mouseDownInside.current) {
      mouseDownInside.current = false;
      return;
    }
    if (!disableOverlayClose) {
      initiateClose();
    }
  };
  const stopPropagation = (e) => { e.stopPropagation(); };
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);
  useEffect(() => {
    if (disableEscapeClose) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        initiateClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isClosing, disableEscapeClose]);
  const popupClassName = `popup ${className} ${isClosing ? 'closing' : ''}`;
  return ReactDOM.createPortal(
    <div className="popup-overlay" onClick={handleOverlayClick}>
      <div className={popupClassName} onClick={stopPropagation} onMouseDown={() => { mouseDownInside.current = true; }} role="dialog" aria-modal="true">
        {(title || onCancel) && (
          <div className="popup-header">
            {title && <div className="popup-title">{title}</div>}
            {onCancel && (
              <button className="popup-close-button" onClick={initiateClose}>
                <span className="popup-close-icon">&times;</span>
              </button>
            )}
          </div>
        )}
        <div className="popup-body">
          {children ? children : <p>{message}</p>}
        </div>
        {footer ? (
          <div className="popup-footer">
            {footer}
          </div>
        ) : (!children && (
          <div className="popup-footer">
            <>
              <button className="popup-btn confirm-btn" onClick={onConfirm}>Yes</button>
              <button className="popup-btn cancel-btn" onClick={initiateClose}>No</button>
            </>
          </div>
        ))}
      </div>
    </div>,
    document.body
  );
};

Popup.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  children: PropTypes.node,
  footer: PropTypes.node,
  className: PropTypes.string,
  disableOverlayClose: PropTypes.bool,
  disableEscapeClose: PropTypes.bool,
};

export default Popup;
